<script lang="ts" setup>
import NormalIcon from '@/assets/icons/normal_icon.png'
import SuccessIcon from '@/assets/icons/success_icon.png'
import ErrorIcon from '@/assets/icons/error_icon.png'
import LoginIcon from '@/assets/icons/login_icon.png'
import WarningIcon from '@/assets/icons/warning_icon.png'
import MTransition from '@/components/common/m-transition.vue'

interface Options {
  icon?: 'normal' | 'success' | 'error' | 'login' | 'warning' | ''
  title?: string
  content?: string
  loading?: any
  buttonText?: string
  maskClose?: boolean
  isRotate?: boolean
}

const props = withDefaults(defineProps<Options>(), {
  icon: '',
  title: '',
  content: '',
  loading: false,
  buttonText: '',
  maskClose: false,
  isRotate: false,
})

const emit = defineEmits(['close'])

const state = reactive({
  isVisible: false,
  type: '',
})

const styleObject = reactive({
  background: 'rgba(0, 0, 0, 0.7)',
  padding: '1.9rem 4.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}) as any

const { isVisible, type } = toRefs(state)

/**
 * 改变组件显隐
 * @param value true(显示) / false(隐藏)
 */
const setVisible = (value: boolean) => {
  isVisible.value = value
}

/**
 * 确认
 */
const handleConfirm = () => {
  isVisible.value = false
  type.value = 'confirm'
}

/**
 * 取消
 */
const handleCancel = ($event: any) => {
  if (props.buttonText || props.maskClose) {
    if ($event.target.className.includes('toast-container')) {
      isVisible.value = false
      type.value = 'cancel'
      emit('close')
    }
  }
}

defineExpose({
  setVisible,
  state,
})
</script>

<template>
  <Teleport to="body">
    <m-transition name="fade">
      <div
        v-show="isVisible"
        :class="['toast-container', isRotate ? 'is-rotate' : '']"
        @click.stop="handleCancel"
      >
        <div
          class="toast-box"
          :style="[icon ? '' : styleObject]"
        >
          <img
            v-if="icon === 'success'"
            :src="SuccessIcon"
            class="icon"
          />
          <img
            v-else-if="icon === 'error'"
            :src="ErrorIcon"
            class="icon"
          />
          <img
            v-else-if="icon === 'login'"
            :src="LoginIcon"
            class="icon"
          />
          <img
            v-else-if="icon === 'normal'"
            :src="NormalIcon"
            class="icon"
          />
          <img
            v-else-if="icon === 'warning'"
            :src="WarningIcon"
            class="icon"
          />
          <h3
            v-if="title"
            class="title"
            :style="{
              color: icon === 'error' ? '#FF7846' : '#42BDFF',
            }"
            v-html="title"
          ></h3>
          <div
            v-if="content"
            class="content"
          >
            <img
              v-if="loading"
              src=""
            />
            <span
              v-if="loading && content"
              style="width: 0.85rem"
            ></span>
            <span
              v-if="content"
              v-html="content"
            ></span>
          </div>
          <div
            v-if="buttonText"
            class="button-box"
          >
            <button
              class="button"
              @click="handleConfirm"
              v-html="buttonText"
            ></button>
          </div>
        </div>
      </div>
    </m-transition>
  </Teleport>
</template>

<style scoped lang="scss">
.toast-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 19999;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .toast-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 1rem;
    max-width: 35rem;
    min-height: 7rem;
    padding: 3rem 2.9rem 2rem;
    box-sizing: border-box;
    .icon {
      width: 10rem;
      height: 10rem;
      top: -8.8rem;
      left: 50%;
      transform: translate(-50%);
      position: absolute;
    }
    .title {
      text-align: center;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 2rem; /* 125% */
      height: 2rem;
      margin-bottom: 1.2rem;
    }
    .content {
      color: $font-white-color;
      font-size: 1.6rem;
      font-weight: 400;
      width: 100%;
      height: 2.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 1.56rem;
        height: 1.69rem;
      }
      span {
        display: block;
      }
    }
    .button-box {
      margin-top: 2rem;
      .button {
        height: 2.8rem;
        line-height: 2.8rem;
        font-size: 1.2rem;
        font-weight: 700;
        color: $font-white-color;
        display: flex;
        padding: 0.4rem 1.2rem;
        justify-content: center;
        align-items: center;
        border-radius: 2rem;
        background: $primary-blue-color;
      }
    }
  }
}
.is-rotate {
  transform: rotate(90deg);
  transform-origin: 'top right';
  width: 100vh;
  height: 100vw;
  width: 100dvh;
  height: 100dvw;
  top: calc(50% - 50vw);
  left: calc(50% - 50vh);
  top: calc(50% - 50dvw);
  left: calc(50% - 50dvh);
}
</style>
